<template>
	<popup
			@updateClosePopup="onClose"
			@updateSave="onSave"
			height-head="40px"
			:title="popupTitle"
			is-all-height
	>
		<div class="employee">
			<div class="employee_left">

				<logo-block
						margin="0"
						:logo="logo"
						title="Employee photo"
						@updateFile="onFile"
				></logo-block>

<!--				Basic Information -->
				<card-slot
						title="Basic Information"
						icon="profile"
				>

					<div class="cardSlotMain">

						<field
								:classError="$v.name.$error"
								margin="0"
								label="Employee name"
								placeholder="Enter employee's full name"
								@updateInput="onInput($event, 'name')"
								:setInputValue="name"
								is-required
						></field>

						<v-radio-group v-model="gender" dense row>
							<v-radio class="gender" label="Male" :value="1"></v-radio>
							<v-radio class="gender" label="Female" :value="2"></v-radio>
						</v-radio-group>

						<field
								margin="0"
								type="text"
								label="Birthday"
								placeholder="Select birthday"
								:dateValue="birthday"
								@updateDate="onDate($event, 'birthday')"
								:dateAllowed="{ isSameOrBefore: true }"
								is-no-title
								is-date
						></field>

						<field
								:classError="$v.phone.$error"
								margin="0"
								label="Phone"
								placeholder="Enter phone"
								@updateInput="onInput($event, 'phone')"
								:setInputValue="phone"
								is-required
								is-phone
						></field>

						<field
								margin="0"
								label="Phone 2"
								placeholder="Enter phone"
								@updateInput="onInput($event, 'phone2')"
								:setInputValue="phone2"
								is-phone
						></field>
					</div>
				</card-slot>

<!--				Account & Role -->
				<card-slot
						title="Account & Role"
						icon="safety"
				>
					<div class="cardSlotMain">
						<field
								v-if="!isCustomers"
								:classError="$v.role.$error"
								margin="0"
								label="Role"
								placeholder="Select role"
								@updateAutocomplete="onAutocomplete($event, 'role')"
								:autocompleteValue="role"
								:items="roles"
								:isClearable="false"
								is-autocomplete
								is-required
						></field>

						<field
								:classError="$v.email.$error"
								margin="0"
								label="Email"
								placeholder="Enter email"
								@updateInput="onInput($event, 'email')"
								:setInputValue="email"
								is-required
								isClip
						></field>

						<field
								margin="0"
								label="Password"
								type="password"
								placeholder="Enter password"
								@updateInput="onInput($event, 'password')"
								:setInputValue="password"
								:is-required="!employeeId"
								is-clip
								is-pass
						></field>

						<field
								:classError="$v.confirm_password.$error"
								margin="0"
								label="Confirm password"
								type="password"
								placeholder="Enter confirm password"
								@updateInput="onInput($event, 'confirm_password')"
								:setInputValue="confirm_password"
								is-clip
								is-pass
						></field>
					</div>
				</card-slot>

<!--				User Settings -->
				<card-slot
						title="User Settings"
						icon="FingerprintAlt"
				>
					<div class="cardSlotMain">
						<field
								label="Biostar ID"
								margin="0"
								type="number"
								placeholder="0"
								@updateInput="onInput($event, 'biostar_id')"
								:setInputValue="biostar_id"
						></field>
						<field
								margin="0"
								padding="0"
								height="24"
								:switch-value="!!active"
								@updateSwitch="onCheckbox($event, 'active')"
								label-switch="Active user status"
								is-dense
								is-switch
								is-off-style
						></field>

						<field
								margin="0"
								padding="0"
								height="24"
								:switch-value="!!show_check_button"
								@updateSwitch="onCheckbox($event, 'show_check_button')"
								label-switch="Show check button"
								is-dense
								is-switch
								is-off-style
						></field>

						<field
								margin="0"
								padding="0"
								height="24"
								:switch-value="!!month"
								@updateSwitch="onCheckbox($event, 'month')"
								label-switch="Monthly operating mode"
								is-dense
								is-switch
								is-off-style
						></field>
					</div>
				</card-slot>
			</div>

<!-- employee_center-->
			<div class="employee_center">

<!--				Employment Details -->
				<card-slot
						title="Employment Details"
						icon="icon-document"
				>
					<div class="cardSlotMain">
						<field
								v-if="!isCustomers"
								margin="0"
								label="Company"
								placeholder="Select company"
								@updateAutocomplete="onAutocomplete($event, 'company_id')"
								:autocompleteValue="company_id"
								:items="company"
								:isClearable="false"
								item-text="value"
								item-value="id"
								is-autocomplete
						></field>

						<field
								margin="0"
								type="text"
								label="Start working date"
								placeholder="Select start working date"
								:dateValue="start_working_date"
								@updateDate="onDate($event, 'start_working_date')"
								:dateAllowed="{ isSameOrBefore: true }"
								is-no-title
								is-date
						></field>
						<item-info-row
								icon-id="bat"
								text="Working days:"
								:value="startWorkingDays"
						></item-info-row>
					</div>
				</card-slot>

<!--				Workplace Information-->
				<card-slot
						title="Workplace Information"
						icon="mapPin"
				>
					<div class="cardSlotMain">

						<field
								label="Office"
								v-if="!isCustomers"
								margin="0"
								placeholder="Select office"
								@updateAutocomplete="onAutocomplete($event, 'office_id')"
								:autocompleteValue="office_id"
								:items="office"
								:isClearable="false"
								item-text="location"
								item-value="office_id"
								is-autocomplete
						></field>

						<item-info-row
								icon-id="icLocation"
								text="Work Location:"
								:value="location"
						></item-info-row>

						<field
								label="Department"
								v-if="!isCustomers"
								margin="0"
								placeholder="Select department"
								@updateAutocomplete="onAutocomplete($event, 'department_id')"
								:autocompleteValue="department_id"
								:items="departments"
								:isClearable="false"
								is-autocomplete
						></field>

						<field
								label="Positions"
								v-if="!isCustomers"
								margin="0"
								:placeholder="gelPlaceholderPositions()"
								@updateAutocomplete="onAutocomplete($event, 'positions_id')"
								:autocompleteValue="positions_id"
								:items="positionsMod"
								:isClearable="false"
								:is-disabled="!department_id"
								is-autocomplete
						></field>

						<field
								label="Schedule"
								v-if="!isCustomers"
								margin="0"
								placeholder="Select schedule"
								@updateAutocomplete="onAutocomplete($event, 'schedule_id')"
								:autocompleteValue="schedule_id"
								:items="schedules"
								:isClearable="false"
								is-autocomplete
						></field>

					</div>
				</card-slot>

<!--				Financial Information -->
			<card-slot
					title="Financial Information"
					icon="dollar-sign"
			>
				<div class="cardSlotMain">
					<field
							label="Salary"
							margin="0"
							type="number"
							placeholder="0"
							@updateInput="onInput($event, 'salary')"
							:setInputValue="salary"
					></field>

					<item-info-row
							icon-id="MoneyReceive"
							text="Balance"
							:value="balance"
					></item-info-row>
				</div>
			</card-slot>
				
			</div>
<!--			employee_center

		-->
			
<!--

employee_right-->
			<div class="employee_right">

<!--				Dispatchers Under Management === Только для Dispatch head   -->
				<card-slot
						v-if="role === 46"
						title="Dispatchers Under Management"
						icon="folderUser"
				>
					<div class="cardSlotMain">
						<div class="cardSlotMainHead">
							<field
									margin="0"
									@updateMultiSelect="onAutocomplete($event, 'employeesHead')"
									:multiValue="employeesHead"
									:items="employeesAll"
									label="Dispatcher list"
									is-multiple
									is-btn-all
									:isClearable="true"
									is-attach
									is-clearable
							></field>
						</div>
						<main-table
								v-if="employeesHead.length"
								padding="0"
								flag="employeesDispatchersList"
								:headers="getHeadersDispatchers"
								:listItems="employeesHead"
								@updateClickButton="onClickButtonTable($event, 'dispatchersList')"
								:is-hide-header="false"
								:items-per-page-amount="500"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
								:is-pagination="false"
						></main-table>
					</div>
				</card-slot>

<!--				Customers Linked to the Employee === Только для Dispatcher  -->
				<card-slot
						v-if="role === 1"
						title="Customers Linked to the Employee"
						icon="dispatch"
				>
					<div class="cardSlotMain">
						<div class="cardSlotMainHead" >
							<div class="employeesCompany" >
								<field
										width="100%"
										margin="0"
										@updateMultiSelect="onAutocomplete($event, 'employeesCompany')"
										:multiValue="employeesCompany"
										:items="customersMod"
										label="Customers"
										is-multiple
										is-btn-all
										:isClearable="true"
										is-attach
										is-clearable
								></field>

								<field
										margin="0"
										width="120px"
										type="number"
										label="Rate amount"
										placeholder="0"
										@updateInput="onInput($event, 'amount')"
										:setInputValue="amount"
										:is-readonly="true"
								></field>
							</div>
						</div>

						<main-table
								v-if="employeesCompany.length"
								padding="0"
								flag="employeesCustomersList"
								:headers="getHeadersCustomers"
								:listItems="employeesCompany"
								@updateClickButton="onClickButtonTable($event, 'customersList')"
								:is-hide-header="false"
								:items-per-page-amount="500"
								:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
								:is-pagination="false"
						></main-table>
					</div>
				</card-slot>

<!--				Exception === Только для Dispatcher-->
				<card-slot
						v-if="role === 1"
						title="Exception"
						icon="accounting"
						is-add-item
						@updateEvent="onAddItem"
				>
					<div v-if="exceptionList.length" class="customerExceptionWrap">
						<template v-for="(item, idx) in exceptionList">
							<div class="customerExceptionItem" :key="idx">
								<field
										:classError="$v.exceptionList.$each.$iter[idx]['customer_id'].$error"
										margin="0"
										label="Customer"
										placeholder="Select customer"
										@updateAutocomplete="onAutocomplete($event, 'customer_id')"
										:autocompleteValue="item.customer_id"
										:items="customers"
										:idx="idx"
										:is-clearable="false"
										is-autocomplete
										is-required
								></field>
								<field
										:classError="$v.exceptionList.$each.$iter[idx]['trailer_type_id'].$error"
										margin="0"
										label="Trailer type"
										placeholder="Select trailer type"
										@updateAutocomplete="onAutocomplete($event, 'trailer_type_id')"
										:autocompleteValue="item.trailer_type_id"
										:items="trailers"
										:idx="idx"
										:is-clearable="false"
										is-autocomplete
										is-required
								></field>
								<field
										:classError="$v.exceptionList.$each.$iter[idx]['amount'].$error"
										margin="0"
										type="number"
										label="Rate amount"
										placeholder="0"
										:idx="idx"
										@updateInput="onInput($event, 'amount')"
										:setInputValue="item['amount']"
										is-required
								></field>

								<button type="button" class="deleteItem" @click="onDeleteItem(idx, item.id)">
									<svg-sprite style="color: #19BC38" width="20" height="20" icon-id="deleteItem"></svg-sprite>
								</button>
							</div>
						</template>
					</div>

				</card-slot>

<!--				List of documents-->
				<employees-wrap-table
						title-table="List of documents"
						flag="documentsList"
						icon="cardUser"
						@updateAddItem="onAddItemTable"
						@updateClickButton="onClickButton"
						:headers="getHeadersDocuments"
						:listItems="documentsList"
				></employees-wrap-table>

<!--				Inventory list-->
				<employees-wrap-table
						title-table="Inventory list"
						flag="InventoryList"
						icon="icon-Inventory"
						icon-height="18px"
						@updateAddItem="onAddItemTable"
						@updateClickButton="onClickButton"
						:headers="getHeadersInventory"
						:listItems="inventory"
				></employees-wrap-table>

<!--				User contacts-->
				<card-slot
						title="User contacts"
						icon="Phone"
						is-add-item
						@updateEvent="onAddContact"
				>
					<div class="rowWrap"
					     v-for="(item) in getListExtension"
					     :key="item.id || item.uniqKey"
					>
						<item-info-row
								icon-id="Phone"
								:text="getExtensionText(item)"
								:value="getExtensionValue(item)"
								isClickValue
								@updateClickValue="onCopyToClipboard(item.value)"
						></item-info-row>
						<div class="btnWrapper">
							<icon-btn
									@updateEvent="onCopyToClipboard(item.value)"
									custom-class="infoBTN"
									:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39',}"
							></icon-btn>
							<icon-btn
									@updateEvent="onEditContact(item)"
									custom-class="infoBTN"
									:icon-attrs="{iconId: 'edit', width: 20, height: 20, color: '#1dab39',}"
							></icon-btn>
							<icon-btn
									@updateEvent="onDeleteExtension(item)"
									custom-class="infoBTN"
									:icon-attrs="{iconId: 'deleteItem', width: 20, height: 20, color: '#1dab39',}"
							></icon-btn>
						</div>
					</div>

					<div class="rowWrap"
					     v-for="(item) in getListMessengers"
					     :key="item.id || item.uniqKey"
					>
						<item-info-row
								:icon-id="item.icon"
								:text="item.name"
								:value="item.value"
								isClickIcon
								isClickValue
								@updateClickIcon="onOpenMessengers(item)"
								@updateClickValue="onCopyToClipboard(item.value)"
						></item-info-row>
						<div class="btnWrapper">
							<icon-btn
									@updateEvent="onCopyToClipboard(item.value)"
									custom-class="infoBTN"
									:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39',}"
							></icon-btn>
							<icon-btn
									@updateEvent="onEditContact(item)"
									custom-class="infoBTN"
									:icon-attrs="{iconId: 'edit', width: 20, height: 20, color: '#1dab39',}"
							></icon-btn>
							<icon-btn
									@updateEvent="onDeleteMessengers(item)"
									custom-class="infoBTN"
									:icon-attrs="{iconId: 'deleteItem', width: 20, height: 20, color: '#1dab39',}"
							></icon-btn>
						</div>
					</div>

				</card-slot>

<!--				Salary calculation formula-->
				<card-slot
						title="Salary calculation formula"
						icon="icon-Formula"
				>
					<field
							margin="0"
							label="Formula"
							placeholder="Enter formula"
							:setInputValue="scf"
							@updateInput="onInput($event, 'scf')"
							is-textarea
					></field>
				</card-slot>

<!--				Payment account information-->
				<card-slot
						title="Payment account information"
						icon="MoneyReceive"
				>
					<template #topButtons>
						<div class="topButtons">
							<v-radio-group v-model="payment_account_type" dense row>

								<v-radio class="payment_account_type" :value="1">
									<template v-slot:label>
										<v-badge
												v-if="account_name"
												color="green"
												dot
										>
											SWIFT
										</v-badge>

										<span v-else>SWIFT</span>
									</template>
								</v-radio>

								<v-radio class="payment_account_type" :value="2">
									<template v-slot:label>
										<v-badge
												v-if="account_name_ach"
												color="green"
												dot
										>
											ACH
										</v-badge>

										<span v-else>ACH</span>
									</template>
								</v-radio>
							</v-radio-group>
						</div>
					</template>
					<div class="mainIBANSWIFT">
						<template v-if="Number(payment_account_type) === 1">

							<field
									:classError="$v.account_name.$error"
									margin="0"
									label="Account name SWIFT"
									placeholder="Enter account name SWIFT"
									@updateInput="onInput($event, 'account_name')"
									:setInputValue="account_name"
									:is-required="Number(payment_account_type) === 1 && (
											(iban && String(iban).length <= 34) ||
											(swift && String(swift).length <= 11)
										)"
									textError="Account name SWIFT is required if IBAN or SWIFT is filled."
							></field>

							<div class="wrapIBANSWIFT">
								<field
										:classError="$v.iban.$dirty && !$v.iban.optionalMaxLengthByType"
										margin="0"
										type="text"
										label="IBAN"
										placeholder="Max. 34 symbol SWIFT"
										@updateInput="onInput($event, 'iban')"
										:setInputValue="iban"
										textError="⚠️ Maximum length is 34 characters."
								></field>

								<field
										:classError="$v.swift.$dirty && !$v.swift.optionalMaxLengthByType"
										margin="0"
										type="text"
										label="SWIFT"
										placeholder="Max. 11 symbol"
										@updateInput="onInput($event, 'swift')"
										:setInputValue="swift"
										textError="⚠️ Maximum length is 11 characters."
								></field>
							</div>

							<field
									margin="0"
									label="Address SWIFT"
									placeholder="Enter address"
									@updateInput="onInput($event, 'address')"
									:setInputValue="address"
							></field>
						</template>

						<template v-else-if="Number(payment_account_type) === 2">
							<field
									:classError="$v.account_name_ach.$error"
									margin="0"
									label="Account name ACH"
									placeholder="Enter account name"
									@updateInput="onInput($event, 'account_name_ach')"
									:setInputValue="account_name_ach"
									:is-required="Number(payment_account_type) === 2 && (
											(payment_account && String(payment_account).length <= 17) ||
											(payment_routing && String(payment_routing).length <= 9)
										)"
									textError="Account name ACH is required if account number or routing number is filled."
							></field>

							<div class="wrapIBANSWIFT">
								<field
										:classError="$v.payment_account.$dirty && !$v.payment_account.optionalMaxLengthByType"
										margin="0"
										type="text"
										label="Account number ACH"
										placeholder="Max. 17 symbol"
										@updateInput="onInput($event, 'payment_account')"
										:setInputValue="payment_account"
										textError="⚠️ Maximum length is 17 characters."
								></field>

								<field
										:classError="$v.payment_routing.$dirty && !$v.payment_routing.optionalMaxLengthByType"
										margin="0"
										type="text"
										label="Routing number ACH"
										placeholder="Max. 9 symbol"
										@updateInput="onInput($event, 'payment_routing')"
										:setInputValue="payment_routing"
										textError="⚠️ Maximum length is 9 characters."
								></field>
							</div>
							
							<field
									margin="0"
									label="Address ACH"
									placeholder="Enter address"
									@updateInput="onInput($event, 'address_ach')"
									:setInputValue="address_ach"
							></field>
						</template>

					</div>

				</card-slot>

			</div>
		</div>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<edit-contact
				v-if="isEditContact"
				:item="editContact"
				:contacts-types="contactsTypes"
				@updateClose="onEditContactClose"
				@updateSave="onSaveContact"
		></edit-contact>

		<edit-inventory
				v-if="isEditInventory"
				:item="activeItem"
				:inventory-types="inventoryTypes"
				@updateClose="onEditInventoryClose"
				@updateSave="onSaveInventory"
		></edit-inventory>
		
		<edit-document
				v-if="isEditDocument"
				:item="activeItem"
				:dialog-flag="dialogFlag"
				:documents-types="documentsTypes"
				@updateClose="onEditDocumentClose"
				@updateSave="onSaveDocument"
				@updateView="onViewPreview"
		></edit-document>

		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link" :file-name="fileName"/>

	</popup>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// components
import LogoBlock from "@/shared/LogoBlock/LogoBlock";
// shared
import Popup from "@/shared/Popup/Popup";
// validations
// import { required, email, sameAs, maxLength } from "vuelidate/lib/validators";
import { required, email, sameAs, helpers } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import {
	employeesTableInventory,
	documentsTableInventory,
	TEXT,
	TITLE,
	documentsTableCustomers, documentsTableDispatchers
} from "@/components/Maintenance/EmployeesForm/constants";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import EmployeesWrapTable from "@/components/Maintenance/EmployeesForm/EmployeesWrapTable/EmployeesWrapTable.vue";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import IconBtn from "@/pages/Account/IconBtn/iconBtn.vue";
import getUniqId from "@/helper/getUniqId";
import checkStringTelegramUserName from "@/helper/checkStringTelegramUserName";
import EditContact from "@/pages/Account/Drawers/EditContact.vue";
import EditInventory from "@/components/Maintenance/EmployeesForm/EditInventory/EditInventory.vue";
import EditDocument from "@/components/Maintenance/EmployeesForm/EditDocument/EditDocument.vue";
import PreviewDoc from "@/modules/invoices/preview.vue";
import { getAppUrl } from "@/services";
import CardSlot from "@/shared/CardSlot/CardSlot.vue";

const optionalMaxLengthByType = function(expectedType, max) {
	return helpers.withParams(
		{ type: 'optionalMaxLengthByType', expectedType, max },
		function(value, vm) {
			if (Number(vm.payment_account_type) !== expectedType) return true;
			if (!helpers.req(value)) return true;

			return String(value).length <= max;
		}
	);
};

const isFilledAndValidByType = function(value, expectedType, currentType, max) {
	if (Number(currentType) !== expectedType) return false;
	if (!helpers.req(value)) return false;

	return String(value).length <= max;
};

const requiredAccountNameByType = function(expectedType, fields) {
	return helpers.withParams(
		{ type: 'requiredAccountNameByType', expectedType, fields },
		function(value, vm) {
			if (Number(vm.payment_account_type) !== expectedType) return true;

			const hasValidRelatedField = fields.some(function(field) {
				return isFilledAndValidByType(
					vm[field.key],
					expectedType,
					vm.payment_account_type,
					field.max
				);
			});

			if (!hasValidRelatedField) return true;

			return helpers.req(value);
		}
	);
};
export default {
	name: "EmployeesForm",
	mixins: [ validationMixin ],
	components: {
		CardSlot,
		PreviewDoc,
		EditDocument,
		EditInventory,
		EditContact,
		IconBtn, ItemInfoRow,
		EmployeesWrapTable,
		DialogRemove,
		Popup,
		LogoBlock,
	},
	props: {
		employeeId: Number,
		permissions: Object,
	},
	computed: {
		...mapGetters([
			'employeesList',
			'filterContract',
			'employeesItem',
			"isCustomers",
			"customersMod",
			"employeesAll"
		]),
		getPermissionAction() {
			return this.permissions[10];
		},
		getHeadersDocuments() {
			return documentsTableInventory;
		},
		getHeadersCustomers() {
			return documentsTableCustomers;
		},
		getHeadersDispatchers() {
			return documentsTableDispatchers;
		},
		getHeadersInventory() {
			return employeesTableInventory;
		},
		getListExtension() {
			return this.contacts ? this.contacts.filter(item => item.extension !== null) : null;
		},
		getListMessengers() {
			return this.contacts ? this.contacts.filter(item => item.extension === null) : null;
		},
	},
	data: () => ({
		documentsTypes: [],
		popupTitle: 'Add employee',
		inventory: [],
		inventoryTypes: null,
		editInventory: null,

		documents: [],
		documentsList: [],
		contacts: [],
		contactsTypes: null,
		editContact: null,
		isEditContact: false,
		positionsMod: null,
		isViewInventory: false,
		dialogFlag: null,
		isEditInventory: false,
		isEditDocument: false,
		logo: null,
		name: '',
		salary: null,
		balance: null,
		birthday: null,
		start_working_date: null,
		startWorkingDays: null,
		biostar_id: null,
		role: null,
		schedule_id: null,
		email: null,
		office_id: null,
		company_id: null,
		password: '',
		confirm_password: '',
		phone: null,
		location: null,
		phone2: null,
		amount: null,
		gender: 1,
		active: false,
		show_check_button: false,
		month: false,
		department_id: null,
		positions_id: null,
		roles: [],
		schedules: [],
		office: [],
		company: [],
		exceptionList: [],
		departments: [],
		positions: [],
		inventoryList: [],
		employeesCompany: [],
		employeesCompanySelect: [],
		employeesHead: [],
		employeesHeadSelect: [],
		isDialogRemove: false,
		activeItem: null,
		activeItemIndex: null,
		nameComponent: null,
		titleRemove: null,
		textRemove: null,
		scf: null,
		link: null,
		fileName: null,
		payment_account_type: 1,
		account_name: null,
		account_name_ach: null,
		address_ach: null,
		iban: null,
		swift: null,
		payment_account: null,
		payment_routing: null,
		address: null,
	}),

	validations() {
		return {
			name: { required },
			phone: { required },
			role: this.isCustomers ? {} : { required },
			email: { required, email },
			confirm_password: {
				sameAsPassword: sameAs('password')
			},
			exceptionList: {
				$each: {
					customer_id: { required },
					trailer_type_id: { required },
					amount: { required },
				}
			},

			account_name: {
				requiredAccountNameByType: requiredAccountNameByType(1, [
					{ key: 'iban', max: 34 },
					{ key: 'swift', max: 11 }
				])
			},

			account_name_ach: {
				requiredAccountNameByType: requiredAccountNameByType(2, [
					{ key: 'payment_account', max: 17 },
					{ key: 'payment_routing', max: 9 }
				])
			},

			iban: {
				optionalMaxLengthByType: optionalMaxLengthByType(1, 34)
			},

			swift: {
				optionalMaxLengthByType: optionalMaxLengthByType(1, 11)
			},

			payment_account: {
				optionalMaxLengthByType: optionalMaxLengthByType(2, 17)
			},

			payment_routing: {
				optionalMaxLengthByType: optionalMaxLengthByType(2, 9)
			},
		};
	},

	methods: {
		...mapActions([ 'setAlert', 'onEmployees', 'onEmployeesSave', 'deleteEmployeesDocuments' ]),

		clearLink() {
			this.link = null;
		},

		// открыть модалку ДОБАВЛЕНИЯ
		onAddContact() {
			this.editContact = null; // чтобы это был add-режим
			this.isEditContact = true;
		},

		//открыть модалку РЕДАКТИРОВАНИЯ
		onEditContact(item) {
			this.editContact = item || null; // защита
			this.isEditContact = true;
		},

		onEditContactClose() {
			this.isEditContact = false;
		},
		onViewPreview(data) {
			this.link = data;
		},
		onSaveContact(args) {
			
			if (this.editContact) {
				this.editContact = null;
				const { uniqKey, id } = args;
				// this.contacts.map(obj =>
				// 	obj.id === uniqId ? args : obj
				// );
				if (id) {
					this.contacts = this.contacts.filter(item => item.id !== id);
				} else {
					this.contacts = this.contacts.filter(item => item.uniqKey !== uniqKey);
				}
				this.contacts.push(args);

			} else {
				const { value } = args;
				const uniqKey = this.uniqKey(value);
				args.uniqKey = uniqKey;
				this.contacts.push(args);

			}

			this.isEditContact = false;
		},
		onSaveInventory(args) {
			if (this.dialogFlag === 'edit') {
				const { uniqKey, id } = args;

				if (id) {
					this.inventory = this.inventory.filter(item => item.id !== id);
				} else {
					this.inventory = this.inventory.filter(item => item.uniqKey !== uniqKey);
				}
				this.inventory.push(args);
			} else {
				const { value } = args;
				const uniqKey = this.uniqKey(value);

				args.uniqKey = uniqKey;
				this.inventory.push(args);
			}
			this.isEditInventory = false;
			this.activeItem = null;
		},
		onSaveDocument(args) {
			if (this.dialogFlag === 'edit') {
				const { uniqKey, id } = args;

				if (id) {
					this.documents = this.documents.filter(item => item.id !== id);
				} else {
					this.documents = this.documents.filter(item => item.uniqKey !== uniqKey);
				}
				this.documents.push(args);
			} else {
				const { type_id, name, value } = args;
				const uniqKey = this.uniqKey(type_id);

				args.uniqKey = uniqKey;
				this.documents.push(args);

				const documentType = this.documentsTypes.filter(item => item.id === type_id);
				this.documentsList.push({ document_name: name, document_path: value, type_id, type_name: documentType[0].name, uniqKey });
			}
			this.isEditDocument = false;
			this.activeItem = null;
		},

		onDeleteExtension(item) {
			this.activeItem = item;
			this.nameComponent = 'extension';
			const title = TITLE.REMOVE_EXTENSION;
			const text = TEXT.REMOVE_EXTENSION;
			this.onRemoveDialog({ title, text });
		},
		onDeleteMessengers(item) {
			this.activeItem = item;
			this.nameComponent = 'messenger';
			const title = TITLE.REMOVE_MESSENGER;
			const text = TEXT.REMOVE_MESSENGER;
			this.onRemoveDialog({ title, text });
		},

		uniqKey(id) {
			return getUniqId() + id;
		},

		getIcon(icon) {
			return `icon-${ icon }`;
		},
		onOpenMessengers(item) {
			const { type, value } = item;
			if (type === 'Telegram') {
				const userName = checkStringTelegramUserName(value);
				const url = 'https://t.me/';
				window.open(`${ url }${ userName }`, '_blank');
			}
			if (type === 'Whatsapp') {
				const url = 'https://wa.me/';
				window.open(`${ url }${ value }`, '_blank');
			}
			if (type === 'Viber') {
				const url = 'viber://chat?number=';
				window.open(`${ url }${ value }`, '_blank');
			}
			if (type === 'Mobile') {
				const url = 'tel:';
				window.open(`${ url }${ value }`, '_blank');
			}
			if (type === 'Email') {
				const url = 'mailto:';
				window.open(`${ url }${ value }`, '_blank');
			}
		},
		onCopyToClipboard(text) {
			navigator.clipboard.writeText(text).then(() => {
				this.setAlert({ type: "success", message: `Successfully copied to clipboard [ <b>${ text }</b> ]` });
			}).catch((err) => {
				console.error('Could not copy text: ', err);
				this.setAlert({ type: "error", message: 'Whoops, something went wrong! 🙁' });
			});
		},

		getExtensionValue(item) {
			return `${ item.value }`;
		},

		getExtensionText(item) {
			return `${ item.extension }:`;
		},

		onAddItemTable(key) {
			if (key === 'InventoryList') {
				this.isEditInventory = true;
				this.dialogFlag = 'add';
			}
			if (key === 'documentsList') {
				this.isEditDocument = true;
				this.dialogFlag = 'add';
			}
		},

		onEditInventoryClose() {
			this.isEditInventory = false;
			this.activeItem = null;
		},
		onEditDocumentClose() {
			this.isEditDocument = false;
			this.activeItem = null;
		},

		onClickButton(args) {
			const { key, item, nameComponent } = args;

			this.nameComponent = nameComponent;
			this.activeItem = item;
			if (key === 'eye') {
				if (nameComponent === 'documentsList') {
					const { document_path, uniqKey, document_name } = item;
					this.fileName = document_name;
					this.link = uniqKey ? document_path : getAppUrl + document_path;
				}
			}
			if (key === 'edit') {
				this.onEditInventory();
			}
			if (key === 'delete') {
				if (nameComponent === 'InventoryList') {
					const title = TITLE.REMOVE_INVENTORY;
					const text = TEXT.REMOVE_INVENTORY;
					this.onRemoveDialog({ title, text });
				}
				if (nameComponent === 'documentsList') {
					const title = TITLE.REMOVE_DOCUMENT;
					const text = TEXT.REMOVE_DOCUMENT;
					this.onRemoveDialog({ title, text });
				}
				if (nameComponent === 'customersList') {
					const name = this.name;
					const { value } = item;
					const title = `Remove customer ${ value }?`;
					const text = `🗑️ Customer ${ value } previously managed by ${ name } will be deleted.`;
					this.onRemoveDialog({ title, text });
				}
				if (nameComponent === 'dispatchersList') {
					const { value } = item;
					const title = `Remove this dispatcher?`;
					const text = `🗑️ Are you sure you want to remove dispatcher “${ value }” from the team?`;
					this.onRemoveDialog({ title, text });
				}

			}
		},
		onClickButtonTable(args, nameComponent) {
			const { key, item } = args;
			
			this.onClickButton({ key, item, nameComponent });
		},

		onEditInventory() {
			this.isEditInventory = true;
			this.dialogFlag = 'edit';
			this.isEditContact = false;
		},

		async onRemove() {
			const flag = this.nameComponent;

			if (flag === 'tabDepartments') {
				const { id } = this.activeItem;
				const employeeId = this.employeeId;
				const values = { employeeId, id };
				
				await this.deleteEmployeesInventory(values);
			}

			if (flag === 'documentsList') {
				const { id } = this.activeItem;
				const values = { id };

				await this.deleteEmployeesDocuments(values);

				this.documentsList = this.documentsList.filter(item => item.id !== id);
			}

			if (flag === 'messenger' || flag === 'extension' || flag === 'InventoryList') {
				this.onRemoveItem();
			}

			if ( flag === 'customersList') {
				const { value, id } = this.activeItem;
				if (id) {
					this.employeesCompany = this.employeesCompany.filter(item => item.id !== id);
					this.setAlert({ type: "info", message: `🧹 <b>${ value }</b> removed. Click <b>Save</b> to confirm.` });
				} else {
					this.setAlert({ type: "error", message: `⚠️ Error: Unable to locate customer with ID <b>${ id }</b>` });
				}
			}
			if ( flag === 'dispatchersList') {
				const { value, id } = this.activeItem;
				if (id) {
					this.employeesHead = this.employeesHead.filter(item => item.id !== id);
					this.setAlert({ type: "info", message: `🧹 <b>${ value }</b> removed. Click <b>Save</b> to confirm.` });
				} else {
					this.setAlert({ type: "error", message: `⚠️ Error: Unable to locate customer with ID <b>${ id }</b>` });
				}
			}
			
			this.onCloseRemove();
		},

		onRemoveItem() {
			const flag = this.nameComponent;

			if (flag === 'messenger' || flag === 'extension') {
				const { uniqKey, id } = this.activeItem;
				if (id) {
					this.contacts = this.contacts.filter(item => item.id !== id);
				} else {
					this.contacts = this.contacts.filter(item => item.uniqKey !== uniqKey);
				}
			}
			if ( flag === 'InventoryList') {
				const { uniqKey, id } = this.activeItem;
				if (id) {
					this.inventory = this.inventory.filter(item => item.id !== id);
				} else {
					this.inventory = this.inventory.filter(item => item.uniqKey !== uniqKey);
				}
			}
			this.activeItem = null;
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		gelPlaceholderPositions() {
			if (this.department_id) {
				return 'Select position';
			}
			return 'Select department';
		},
		onDate(value, key) {
			this[key] = value;

			if (key === 'start_working_date') {
				this.onUpdateStartWorkingDate(value);
			}
		},

		onUpdateStartWorkingDate(value) {
			const currentDate = new Date();
			const startWorkingDate = new Date(value);

			// Разница в миллисекундах
			const differenceInMilliseconds = currentDate - startWorkingDate;

			// Переводим разницу в дни
			const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

			this.startWorkingDays = differenceInDays; // Количество отработанных дней
		},
		// onCheckbox({ value }) {
		// 	this.active = value;
		// },
		onCheckbox({ value }, key) {
			if (key === 'active') {
				this[key] = value ? 1 : 0;
			} else {
				this[key] = value;
			}
		},
		onAddItem() {
			const values = {
				trailer_type_id: null,
				customer_id: null,
				id: null,
				amount: 0
			};

			this.exceptionList.push(values);
		},
		onDeleteItem(idx) {
			this.exceptionList.splice(idx, 1);
		},
		onInput({ value, idx }, key) {
			if (idx !== undefined) {
				this.exceptionList[idx][key] = value;
				return;
			}

			this[key] = value;

			if (this.$v && this.$v[key]) {
				this.$v[key].$touch();
			}
		},
		onAutocomplete({ value, idx }, key) {
			if (idx !== undefined) {
				this.exceptionList[idx][key] = value?.id ?? value;
				return false;
			}

			this[key] = value?.id ?? value;

			if (key === 'department_id') {
				const { id } = value;
				this.positionsMod = this.positions.filter(item => item.department_id === id);
			}
			if (key === 'office_id') {
				this.onUpdateLocation(value);
				this.office_id = value?.office_id;
			}
		},
		onUpdateLocation(value) {
			const { name } = value;
			this.location = name;
		},
		onClose(isRefresh) {
			this.$emit('updateClose', isRefresh);
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					logo,
					name,
					salary,
					balance,
					birthday,
					start_working_date,
					biostar_id,
					email,
					phone,
					location,
					phone2,
					office_id,
					company_id,
					employeesCompany,
					employeesHead,
					gender,
					password,
					active,
					show_check_button,
					month,
					role,
					schedule_id,
					department_id,
					positions_id,
					exceptionList,
					contacts,
					inventory,
					scf,
					documents,
					account_name,
					account_name_ach,
					address_ach,
					iban,
					swift,
					payment_account,
					payment_routing,
					payment_account_type,
					address,
				} = this.$data;
				const values = {
					logo,
					name,
					salary,
					balance,
					birthday,
					start_working_date,
					biostar_id,
					email,
					phone,
					location,
					phone2,
					office_id,
					company_id,
					employeesCompany,
					employeesHead,
					gender,
					password,
					active,
					show_check_button,
					month,
					department_id,
					positions_id,
					role_id: role,
					schedule_id,
					trailer_rate: exceptionList,
					contacts,
					inventory,
					scf,
					documents,
					account_name,
					account_name_ach,
					address_ach,
					iban,
					swift,
					payment_account,
					payment_routing,
					payment_account_type,
					address,
				};

				const { status } = await this.onEmployeesSave({ values, id: this.employeeId });

				if (status) {
					this.setAlert({ type: "success", message: `✅ Great! Employee <b>${ name }</b> has been successfully saved 🎉` });
					this.onClose(1);
				} else {
					this.setAlert({ type: "error", message: "Saving error" });
				}
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
		},
		onFirstTab({ value, key }) {
			this[key] = value;
		},
		onFile(values) {
			this.logo = values;
		},
	},
	async mounted() {

		await this.onEmployees(this.employeeId);

		const {
			customers,
			type,
			schedule,
			office,
			company,
			employeesCompany,
			employeesHead,
			trailers,
			dispatcher_rate,
			employees,
			trailer_rate,
			users,
			departments,
			positions,
			contactsTypes,
			inventoryTypes,
			inventory,
			documents,
			contacts,
			documentsTypes,
			employeesAll,
		} = this.employeesItem;

		this.customers = customers;
		this.office = office;
		this.company = company;
		this.employeesCompany = this.customers.filter(obj => (employeesCompany || []).includes(obj.id));
		this.employeesCompanySelect = this.customers.filter(obj => (employeesCompany || []).includes(obj.id));
		this.employeesHead = employeesAll.filter(obj => (employeesHead || []).includes(obj.id));
		this.employeesHeadSelect = employeesAll.filter(obj => (employeesHead || []).includes(obj.id));
		this.roles = type;
		this.schedules = schedule;
		this.trailers = trailers;
		this.amount = dispatcher_rate;
		this.departments = departments;
		this.positions = positions;
		this.contactsTypes = Object.values(contactsTypes);
		this.inventoryTypes = Object.values(inventoryTypes);
		this.inventory = inventory;
		this.contacts = contacts ? contacts : [];
		this.documentsTypes = documentsTypes;

		if (documents && documents.length > 0) {

			// this.documentsList = documents;
			this.documentsList = documents.map(doc => {
				// Ищем соответствующий тип документа
				const docType = documentsTypes.find(type => type.id === doc.type_id);

				// Добавляем новое поле type_name
				return {
					...doc, // копируем все свойства объекта doc
					type_name: docType ? docType.name : null // добавляем type_name, если найден тип
				};
			});
		}

		if (employees) {
			const {
				salary,
				balance,
				birthday,
				start_working_date,
				biostar_id,
				email,
				logo,
				name,
				office_id,
				company_id,
				// employeesCompany,
				department_id,
				positions_id,
				phone,
				location,
				phone2,
				role_id,
				schedule_id,
				gender,
				show_check_button,
				month,
				scf,
				account_name,
				account_name_ach,
				address_ach,
				iban,
				swift,
				payment_account,
				payment_routing,
				payment_account_type,
				address,
			} = employees;

			// console.log('%c [  employeesCompany  ] ', 'color:#bada55', typeof employeesCompany, employeesCompany );
			this.scf = scf;
			this.salary = salary;
			this.balance = balance;
			this.birthday = birthday;
			this.start_working_date = start_working_date;
			this.biostar_id = biostar_id;
			this.email = email;
			this.name = name;
			this.phone = phone;
			this.location = location;
			this.phone2 = phone2;
			this.role = role_id;
			this.schedule_id = schedule_id;
			this.department_id = department_id;
			this.positions_id = positions_id;
			this.office_id = office_id;
			this.company_id = company_id;
			// this.employeesCompany = this.customers.filter(obj => (employeesCompany || []).includes(obj.id));
			// this.employeesCompanySelect = this.customers.filter(obj => (employeesCompany || []).includes(obj.id));
			this.logo = logo;
			this.gender = Number(gender);
			this.exceptionList = trailer_rate;
			this.active = users?.active;
			this.show_check_button = show_check_button;
			this.month = month;
			this.account_name = account_name;
			this.account_name_ach = account_name_ach;
			this.address_ach = address_ach;
			this.iban = iban;
			this.swift = swift;
			this.payment_account = payment_account;
			this.payment_routing = payment_routing;
			this.payment_account_type = Number(payment_account_type == null ? 1 : payment_account_type);
			this.address = address;

			if (start_working_date) this.onUpdateStartWorkingDate(this.start_working_date);

			const locationMod = (this.office || []).find(function(it) {
				return it.office_id === office_id;
			});

			this.location = locationMod ? locationMod.name : null;

			this.positionsMod = positions;
			this.popupTitle = 'Edit employee';
		}
	},
	watch: {
		// payment_account_type(value) {
		// 	this.$v.$reset();
		// 	console.log('%c [  value  ] ', 'color:#bada55', typeof value, value );
		//
		// 	// if (value === 1) {
		// 	// 	this.payment_account = null;
		// 	// 	this.payment_routing = null;
		// 	// }
		// 	//
		// 	// if (value === 2) {
		// 	// 	this.iban = null;
		// 	// 	this.swift = null;
		// 	// }
		// }
		payment_account_type(value) {
			const normalizedValue = Number(value);

			if (normalizedValue !== value) {
				this.payment_account_type = normalizedValue;
				return;
			}

			if (this.$v) {
				this.$v.iban && this.$v.iban.$reset();
				this.$v.swift && this.$v.swift.$reset();
				this.$v.payment_account && this.$v.payment_account.$reset();
				this.$v.payment_routing && this.$v.payment_routing.$reset();
			}
		}
	},
};
</script>

<style scoped lang="scss">
@import "employees";
</style>
